export const helpSendRequest = async (url, headers, method, body) => {
  try {
    const options = method === 'GET' ? { method: method, headers: headers }
      : { method: method, headers: headers, body: body }

    const response = await fetch(url, options);
    return response.json();
  } catch (error) {
    return error;
  }
};

export const sendRequestFile = async (url, headers, method, body) => {
  try {
    const options = method === 'GET' ? { method: method, headers: headers }
      : { method: method, headers: headers, body: JSON.stringify(body) }

    const response = await fetch(url, options);
    return response.status!=200?null:response.blob();
  } catch (error) {
    return error;
  }
};